<a *ngIf="isMock" class="link" href="{{ nextWorkflowRoute }}?jwt={{ jwt }}">
	<ng-container *ngIf="secondsLeftBeforeExpire$ | async as secondsLeft; else continueToExpiredWorkflowTpl">
		Continue to {{ nextWorkflowRoute }} Workflow (expires in {{ secondsLeft }})
	</ng-container>

	<ng-template #continueToExpiredWorkflowTpl> Continue To Expired Workflow </ng-template>
</a>
